import { quarterEnd, quarterStart, today, yesterday } from '@shared/utils'

import type { TimeRangePickerProps } from 'antd'

export const rangePresets: TimeRangePickerProps['presets'] = [
  {
    label: 'today',
    value: [today, today]
  },
  {
    label: 'yesterday',
    value: [yesterday, yesterday]
  },
  {
    label: 'this_week',
    value: [today.startOf('week'), today.endOf('week')]
  },
  {
    label: 'this_month',
    value: [today.startOf('month'), today.endOf('month')]
  },
  {
    label: 'this_quarter',
    value: [quarterStart, quarterEnd]
  },
  {
    label: 'this_year',
    value: [today.startOf('year'), today.endOf('year')]
  },
  {
    label: 'previous_week',
    value: [
      today.subtract(1, 'week').startOf('week'),
      today.subtract(1, 'week').endOf('week')
    ]
  },
  {
    label: 'previous_month',
    value: [
      today.subtract(1, 'month').startOf('month'),
      today.subtract(1, 'month').endOf('month')
    ]
  },
  {
    label: 'previous_year',
    value: [
      today.subtract(1, 'year').startOf('month'),
      today.subtract(0, 'year').endOf('month')
    ]
  }
]
